/** Pluggable key/value persistence for identity (localStorage in browser, Tauri store, etc.). */
export interface ArcadeStorage {
  get(key: string): string | null | Promise<string | null>;
  set(key: string, value: string): void | Promise<void>;
}

/** localStorage when available (browser / Tauri webview), else an in-memory fallback. */
export function defaultStorage(): ArcadeStorage {
  if (typeof localStorage !== "undefined") {
    return {
      get: (k) => localStorage.getItem(k),
      set: (k, v) => localStorage.setItem(k, v),
    };
  }
  const mem = new Map<string, string>();
  return {
    get: (k) => mem.get(k) ?? null,
    set: (k, v) => {
      mem.set(k, v);
    },
  };
}
